import * as yup from "yup";

export const flowLogoUrl = "/flow/images/flow-base/logos/flow.jpg";

export const formDefaultValues = {
    username: "",
    password: "",
};

export const formValidationSchema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
})

export const ERROR_TYPE_INVALID_CREDENTIALS = "INVALID_CREDENTIALS";
